import styled, { css } from 'styled-components';

import { weights } from '@utils/fonts';
import colors from '@utils/colors';
import { mq } from '@utils/responsive';
import { fontStyles, Heading } from '@components/type';
import { textBoxHeadings } from '../Text/styles';

export const Wrapper = styled.div``;

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 24px;
  gap: 24px;

  ${mq.gtms`
    gap: 60px;
    max-width: 1280px;
    margin: 0 auto;

    ${(props) =>
  props.align === 'left'
    ? css`
      flex-direction: row;
    `
    : css`
      flex-direction: row-reverse;
    `}
  `}
`;

export const Content = styled.div`
  ${mq.gtms`
    flex: 1 1 0;
    min-width: 0;
  `};
`;

function getTitleColor(colorTheme) {
  switch (colorTheme) {
    case 'yellow':
      return colors.Y500;
    case 'green':
      return colors.G500;
    case 'orange':
      return colors.O500;
    case 'purple':
      return colors.P500;
    default:
      return colors.B500;
  }
}

export const Title = styled(Heading)`
  margin-top: 24px;
  margin-bottom: 36px;
  text-transform: uppercase;
  color: ${(props) => getTitleColor(props.colorTheme)};

  ${mq.gtms`
    max-width: 70%;
    margin-top: 0;
  `}
`;

export const TextWrapper = styled.div`
  margin-bottom: 24px;

  &:has(ul), &:has(ol) {
    margin-bottom: 0;
  }

  & p {
    ${fontStyles.normal};
  }

  ${textBoxHeadings};

  & blockquote {
    ${fontStyles.blockquote};
  }

  & em {
    ${fontStyles.em};
  }

  & strong {
    ${fontStyles.strong};
  }

  & ul {
    ${fontStyles.normal};
    padding-left: 40px;
    list-style-type: disc;
  }
`;

export const ImagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  ${(props) => props.$sized && css`
    align-items: center;
  `}

  ${mq.gtms`
    flex: 1 1 0;
    min-width: 0;
    margin-top: 8px;
  `};
`;

export const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Credit = styled.div`
  font-weight: ${weights.BOLD};
  font-family: ${props => props.theme.fonts.SANS};
  font-size: 12px;
`;
